import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  FormControl,
  Validators,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { marker as TRANSLATE_ME } from "@biesbjerg/ngx-translate-extract-marker";
import { CrudService } from "../../Services/crud.service";
import { Router } from "@angular/router";
import { FormStateService } from "src/app/Services/form.service";

@Component({
  selector: "app-forgot-password",
  templateUrl: "./forgot-password.component.html",
  standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
  registerForm: UntypedFormGroup;
  submitted = false;

  DEAULT_ERROR_MESSAGE = {
    EMAIL: "Email is require.",
  };

  model = new CompanyRegistrationModel(this.DEAULT_ERROR_MESSAGE.EMAIL);

  constructor(
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private crudService: CrudService,
    private router: Router,
    private formStateService: FormStateService
  ) {
    this.translateService.setDefaultLang("en");
    let language = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : "en";
    this.translateService.use(language);
  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      emailId: ["", [Validators.required, Validators.email]],
    });
    this.registerForm.valueChanges.subscribe(() => {
      if (this.registerForm.dirty) {
        this.formStateService.setFormDirty();
      }
    });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  onSubmit() {
    var self = this;
    this.submitted = true;

    // stop here if form is invalid
    if (this.registerForm.invalid) return;

    var payload = { email: self.registerForm.value.emailId };

    // submit API call
    self.crudService.post(
      payload,
      function (pResponse) {
        if (pResponse.error) {
          let errorMessage = "Something went wrong. Please try again.";

          if (pResponse.error.error.message === "DoesNotExist") {
            errorMessage = "The user does not exist or is inactive.";
          }

          self.toastr.error(errorMessage, "Error");
        } else {
          self.toastr.success("Email sent successfully", "Success");
          self.router.navigate(["thankyou-page", "setpassword"]);
        }
        self.formStateService.clearFormDirty();
      },
      "userManagements/reset"
    );
  }

  onReset() {
    this.submitted = false;
    this.registerForm.reset();
    this.formStateService.clearFormDirty();
  }
}

class CompanyRegistrationModel {
  constructor(public emailId?: string) {}
}
